export default __webpack_public_path__ + "images/models/846c709dbdeb02e3e542f6e418e5d0cc.glb";